import React from "react"
import "./pattern.scss";

const Pattern = () => (
    <div className="pattern"></div>
)

export default Pattern
